import en from './en.json'
import de from './de.json'
import cs from './cz.json'
import fr from './fr.json'
import it from './it.json'
import ro from './ro.json'
import sr from './sr.json'
import pl from './pl.json'

export const defaultLocale = 'de'

export const languages = {
  en,
  de,
  cs,
  fr,
  it,
  ro,
  sr,
  pl
}
